import React, {useEffect, useState} from "react";
import {message} from "antd";
import Advantage from "./compenents/advantage";
import styles from './index.module.scss';
import HhxCarousel from "../../compenents/carousel";
import bannerApi from "../../api/banner";
import cardApi from "../../api/card";
import ServerCardList from "./compenents/server-card";

const HomePage = () => {

    const [images, setImages] = useState([]);
    const [serverCard, setServerCard] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        bannerApi.list({
            type: bannerApi.BannerType.HOME_PAGE,
        }).then(res => {
            setImages(res.data.map(item => ({
                id: item.id,
                imgUrl: item.imgUrl,
                jumpUrl: item.jumpUrl,
            })))
        }).catch(e => messageApi.error(e.msg))
    }, [messageApi]);

    useEffect(() => {
        cardApi.list().then(res => setServerCard(res.data)).catch(e => messageApi.error(e.msg))
    }, [messageApi]);

    const handleCarouselClick = (url) => window.open(url, "_blank");

    return (
        <div>
            {contextHolder}
            <HhxCarousel images={images} onClick={handleCarouselClick}/>

            <div className="section">
                <div className="container">
                    <div className={styles['home-content']}>
                        <Advantage/>
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="container">
                    <div className={styles['home-content']}>
                        <ServerCardList data={serverCard}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomePage